import dotProp from 'dot-prop-immutable'

import * as actions from '../actionTypes'

const initialState = {
  error: null,
  isAttemptingLogin: false,
  isAuthenticated: false,
  isInitialized: false,
  user: null,
}

const authenticationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.AUTHENTICATION_CHECK:
      return { ...state, isAuthenticated: action.payload.isAuthenticated, isInitialized: true }
    case actions.LOGIN_REQUEST:
      return dotProp.set(state, 'isAttemptingLogin', true)
    case actions.LOGIN_REQUEST_FAILURE:
      return {
        ...state,
        error: action.payload.response,
        isAttemptingLogin: false,
        isAuthenticated: false,
        user: null,
      }
    case actions.LOGIN_REQUEST_SUCCESS:
      return {
        ...state,
        error: null,
        isAttemptingLogin: false,
        isAuthenticated: true,
        user: action.payload.user,
      }
    case actions.LOGOUT_REQUEST_SUCCESS:
      return {
        ...state,
        error: null,
        isAuthenticated: false,
        user: null,
      }
    default:
      return state
  }
}

export default authenticationReducer
